/* index.js
 * Looks for embed codes on the page with class "simplestream-autoload" 
 * and initializes a Simplestream player instance.
 */

// import 'shaka-player/dist/controls.css';
// import shaka from 'shaka-player/dist/shaka-player.ui.js';
import SimplestreamPlayer from './player.js';

(function(global) {

  let ssmp;
  let plugins = (document.currentScript.src.match(/[?&]plugins=([^&]+)/)?.[1]?.toLowerCase().split(',')) ?? [];
  let debug = new URLSearchParams(new URL(window.location.href).search).get('debug');

  function init() {
    console.log('Google Shaka Player v4.11.7');
    loadScript('https://ajax.googleapis.com/ajax/libs/shaka-player/4.11.7/shaka-player.ui' + (debug ? '.debug' : '') + '.js', function() {
      if(shaka.Player.isBrowserSupported()) {
          shaka.polyfill.installAll();
          initPlayers();
      } else {
          alert('Browser does not support Google Shaka Player!');
      }
    });
  }

  function initPlayers() {
    var players = document.getElementsByClassName('simplestream-autoload');
    for (var i = 0; i < players.length; ++i) {
        initPlayer(players[i].id, plugins);
    }
  }

  function initPlayer(playerId) {
    ssmp = new SimplestreamPlayer(playerId, plugins);
  }

  function getPlayer(playerId) {
    return ssmp.get();
  }

  function destroyPlayer(playerId) {
    return ssmp.destroy();
  }

  function loadScript(url, callback) {
    var script = document.createElement('script');
    script.type = 'text/javascript';
    if (script.readyState) {  // Only required for old IE
        script.onreadystatechange = function () {
            if (script.readyState == 'loaded' || script.readyState == 'complete') {
                script.onreadystatechange = null;
                callback();
            }
        };
    } else {  // Others
        script.onload = function () {
            callback();
        };
    }
    script.src = url;
    document.getElementsByTagName('head')[0].appendChild(script);
  }

  global.simplestream = {
    init: init,
    initPlayer: initPlayer,
    getPlayer: getPlayer,
    destroyPlayer: destroyPlayer
  }

})(window);

document.addEventListener('DOMContentLoaded', function() {
  window.simplestream.init();
}, false);